// extracted by mini-css-extract-plugin
export default {"td-actions":"budgetModalFull_td-actions__q7lyJ","summary-line":"budgetModalFull_summary-line__-6qY1"};